export const statusStyle = (status) => {
    if (!status) {
        return { "style": "", "title": "Đặt hàng thành công" };
    }

    switch (status.toLowerCase()) {
        case "cancel":
            return { "style": "cancel", "title": "Huỷ đơn hàng", "trackingStyle": "active cancel" };
        case "created":
            return { "style": "", "title": "Đặt hàng thành công", "trackingStyle": "active" };
        case "validated":
            return { "style": "", "title": "Xác nhận đơn hàng", "trackingStyle": "active" };
        case "to be prepared":
            return { "style": "shipping", "title": "Đang giao đến bưu cục vận chuyển", "trackingStyle": "active shipping" };
        case "prepared":
            return { "style": "delivered", "title": "Đang vận chuyển", "trackingStyle": "active shipping" };
        case "Package given to carrier":
            return { "style": "delivered", "title": "Giao hàng thành công", "trackingStyle": "active delivered" };
        case "complete":
            return { "style": "delivered", "title": "Giao hàng thành công", "trackingStyle": "active cadeliveredncel" };
        default:
            return { "style": "", "title": "Đặt hàng thành công", "trackingStyle": "active" };
    }

};